var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"box"},[_c('a',{attrs:{"href":_vm.backgroundImage,"data-size":_vm.imageSize}},[_c('img',{attrs:{"data-src":`background:url(${_vm.backgroundImage});`,"src":_vm.backgroundImage}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }